import { createStore } from 'effector';

export const $activeFilters = createStore({});
$activeFilters.watch((state) => console.log('$activeFilters', state));

export const $activeProjects = createStore([]);
$activeProjects.watch((state) => console.log('$activeProjects', state));

export const $activeRegions = createStore([]);
$activeRegions.watch((state) => console.log('$activeRegions', state));
